/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EvmAddressSummaryInfo } from './EvmAddressSummaryInfo';
import type { EvmTokenSummaryInfo } from './EvmTokenSummaryInfo';

export type ZerogTokenTransferInfo = {
    STAT: ZerogTokenTransferInfo.STAT;
    TRXHA: string;
    AG: string;
    UT: number;
    MTH: string;
    ACTTP: ZerogTokenTransferInfo.ACTTP;
    BNO: string;
    ADDRSFROMINFO: EvmAddressSummaryInfo;
    ADDRSTOINFO: EvmAddressSummaryInfo;
    AMT: string;
    VAL: string;
    LGIDX: string;
    TI: string;
    TSI: EvmTokenSummaryInfo;
};

export namespace ZerogTokenTransferInfo {

    export enum STAT {
        SUCCESS = 'SUCCESS',
        FAILURE = 'FAILURE',
        PENDING = 'PENDING',
        FAILED = 'FAILED',
        OUT_COMING = 'OUT_COMING',
        IN_COMING = 'IN_COMING',
        ALL = 'ALL',
    }

    export enum ACTTP {
        MINT = 'MINT',
        BURN = 'BURN',
        TRANSFER = 'TRANSFER',
        MUTATE = 'MUTATE',
        BIDDING = 'BIDDING',
        CANCEL_BIDDING = 'CANCEL_BIDDING',
        COLLECTION_BIDDING = 'COLLECTION_BIDDING',
        COLLECTION_CANCEL_BIDDING = 'COLLECTION_CANCEL_BIDDING',
        LISTING = 'LISTING',
        DELIST = 'DELIST',
        SOLD = 'SOLD',
        UPDATE_PRICE = 'UPDATE_PRICE',
        CREATE_TOKEN = 'CREATE_TOKEN',
        CREATE_COLLECTION = 'CREATE_COLLECTION',
        WITHDRAW = 'WITHDRAW',
        DEPOSIT = 'DEPOSIT',
        OBJECT_CORE = 'OBJECT_CORE',
        DELETE_RESOURCE = 'DELETE_RESOURCE',
    }


}

